import {
	createRootRoute,
	createRouter,
	createRoute,
	AnyRoute,
} from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';

import { Preview } from '@/components/preview/Preview';
import Drafts from '@/views/drafts/Drafts';
import { AUTH_KEY } from '@/views/home/auth/Authentication.hooks';
import { IssueView } from '@/views/issue/Issue';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

import { Home } from './home/Home';
import { Logout } from './auth/Logout';

import { Callback } from './callback/Callback';
import { Subscriptions } from './subscriptions/Subscriptions';
import { Success } from './subscriptions/success/Success';

import { logOut } from './auth/Auth.hooks';

import { NotFound, RootRouteComponent } from '@/views/RootRoute';

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const onClickLogOut = localStorage.getItem(AUTH_KEY)
	? (url?: string): void => {
			console.log(`Click logout to the followin url: ${url}`);
			logOut(url || '/logout');
	  }
	: undefined;

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: () => <Home onClickLogOut={onClickLogOut} />,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: () => <IssueView onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: () => <IssueView onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Preview,
	path: 'preview/$id',
});

const subscriptionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Subscriptions,
	path: 'subscriptions',
});

const subscriptionsSuccessRoute = createRoute({
	getParentRoute: () => subscriptionsRoute,
	component: Success,
	path: 'success',
});

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Callback,
	path: 'callback',
});

const logOutRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Logout,
	path: 'logout',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issueRoute,
	issueArticleRoute,
	previewRoute,
	subscriptionsRoute,
	subscriptionsSuccessRoute,
	callbackRoute,
	logOutRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
